// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8cd39317","295":"fda7b1f3","347":"5d312eb9","617":"632f6dda","669":"90ba9e22","858":"321e6001","988":"1161bbe3"}[chunkId] + ".chunk.js";
};